import {
  GET_MY_BATCHES,
  GET_MY_EXAMS,
  GET_MY_EXAM_SUBJECTS,
  CLEAR_REDUCER,
  GET_STUDENT_EXAM_MARK,
  GET_BATCH_EXAMS,
  GET_BATCH_COURSE_EXAMS,
  GET_EXAM,
  GET_ALL_EXAM_TYPES,
} from 'actions/admin/marks';

const initialState = {
  myBatchList: [],
  myExamsList: [],
  myExamSubjectList: [],
  studentExamMarkList: [],
  batchExamList: [],
  // batchCourseExamList: [],
  exam: {},
  examTypes: [],
  batchCourseExam: {},
};

const marks = (state = initialState, action) => {
  switch (action.type) {
    case GET_MY_BATCHES: {
      return { ...state, myBatchList: action.batchData };
    }
    case GET_MY_EXAMS: {
      return { ...state, myExamsList: action.examData };
    }
    case GET_MY_EXAM_SUBJECTS: {
      return { ...state, myExamSubjectList: action.subjectData };
    }
    case CLEAR_REDUCER: {
      return initialState;
    }
    case GET_STUDENT_EXAM_MARK: {
      return { ...state, studentExamMarkList: action.marks };
    }
    case GET_BATCH_EXAMS: {
      return { ...state, batchExamList: action.exams };
    }
    case GET_BATCH_COURSE_EXAMS: {
      return {
        ...state,
        // batchCourseExamList: action.batchCourseExams,
        batchCourseExam: { ...state.batchCourseExam, [action.mainExamType]: action.batchCourseExams },
      };
    }
    case GET_EXAM: {
      return { ...state, exam: action.exam };
    }
    case GET_ALL_EXAM_TYPES: {
      return { ...state, examTypeList: action.examTypes };
    }
    default:
      return state;
  }
};

export default marks;
